/**
 * Recursively dig through a value; if you find a string that parses as JSON,
 * replace it with the parsed result, then keep digging.
 */
function parseDeep(value) {
  // Try to parse strings that look like JSON
  if (typeof value === 'string') {
    try {
      // quick check: must start with { or [
      if (/^[\[{]/.test(value.trim())) {
        return parseDeep(JSON.parse(value));
      }
    } catch (_) {
      /* not valid JSON → leave string as‑is */
    }
    return value;                     // plain string
  }

  // Recurse into arrays
  if (Array.isArray(value)) {
    return value.map(parseDeep);
  }

  // Recurse into objects (skip null)
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, parseDeep(v)])
    );
  }

  // Numbers, booleans, null, undefined
  return value;
}

/**
 * Main helper.
 * @param {any} input   – your raw data (object, array, or JSON string)
 * @param {boolean} prettify – if true, returns a pretty JSON string
 */
export function formatNestedJson(input, prettify = true) {
  const parsed = parseDeep(
    typeof input === 'string' ? JSON.parse(input) : input
  );

  // Pretty print or just hand back the parsed structure
  return prettify ? JSON.stringify(parsed, null, 2) : parsed;
}